export default __webpack_public_path__ + "static/agency-user6-08feaa61caead2e94c253ba3fd149485.png";